import { render } from "./AccesObertView.vue?vue&type=template&id=9735a1ba"
import script from "./AccesObertView.vue?vue&type=script&lang=js"
export * from "./AccesObertView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__